var twig = require("twig").twig,
    tokens = [],
    template = twig({"id":"$resolved:8324e6da514957f514e7af0bf7780818c32d03c16c0e204b63ab76bceb804c5921d9ea295e38f6c8261d053eb469959c834df3d324539d75846c5942a3dc40c1:topic-favorite.twig","data":[],"allowInlineIncludes":true,"rethrow":true});

module.exports = function(context) { return template.render(context); }

module.exports.tokens = tokens;